import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { Grid, ImageListItem } from '@mui/material';
import { Chip } from '~/views/atoms/chip/chip';
import { useStyles } from '~/views/organisms/file-info-connected-user/tags/styles';
export const Tags = ({ tags }) => {
    const classes = useStyles();
    return (_jsx(Fragment, { children: _jsx(ImageListItem, { className: 'file-info', children: _jsx(Grid, { container: true, children: tags?.map((tag, index) => (_jsx(Grid, { className: classes.chipItem, item: true, children: _jsx(Chip, { label: tag.label }) }, index))) }) }) }));
};
